import React from "react";

const ManagerMenu=({logout,setMenu})=>{
    return(
        <div className={'manager-menu-container'}>
            <div className={'manager-menu-item'} onClick={()=>{setMenu(0)}}>
                <span>상품관리</span>
            </div>
            <div className={'manager-menu-item'} onClick={()=>{setMenu(1);}}>
                <span>예약관리</span>
            </div>
            <div className={'manager-menu-item'} onClick={()=>{setMenu(2)}}>
                <span>통계</span>
            </div>
            <div className={'manager-menu-item'} onClick={()=>{logout()}}>
                <span>로그아웃</span>
            </div>
        </div>
    )

}

export default ManagerMenu;

